// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "img {\n  width: 100% !important;\n  height: 100% !important;\n}\n.content span {\n  font-size: 4vw !important;\n  font-family: Source Han Sans CN;\n  font-weight: 320 !important;\n  color: #fff !important;\n  opacity: 1;\n  background: transparent !important;\n}\n.content a {\n  color: #FFB400 !important;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
